import React, { forwardRef } from 'react';
import styles from './Badge.module.css';
import cn from 'classnames';
import Skeleton from '../Skeleton/Skeleton';

type BadgeProps = {
    children?: React.ReactNode | undefined;
    className?: string;
    onClick?: () => void;
    loading?: boolean;
};

const Badge = forwardRef<HTMLDivElement, BadgeProps>(({ children, className, loading, onClick }, ref) => (
    <>
        {loading ? (
            <Skeleton className={cn(styles.badge, className, styles.skeleton)} />
        ) : (
            <div ref={ref} className={cn(styles.badge, className)} onClick={onClick}>
                {children}
            </div>
        )}
    </>
));

export default Badge;
